module.exports = __webpack_public_path__ + "static/media/hero-where-to-buy.89c69327.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/whereToBuy/hero-where-to-buy.jpg
// module id = 209
// module chunks = 0